import { render } from "./App.vue?vue&type=template&id=424e4cc2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=424e4cc2&lang=css"

import exportComponent from "C:\\Users\\a1bg493225\\Desktop\\logika\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__